import * as XLSX from 'xlsx';
interface ExcelData {
  headers: { title: string; key: string }[];
  rows: Record<string, any>[];
}


const handleFileUpload = (file: any): Promise<ExcelData> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    const reader = new FileReader();

    reader.onload = (event: any) => {
      try {
        const data = new Uint8Array(event.target.result);
        // 1. Added cellDates: true to automatically convert Excel date serials to JS Dates
        const workbook = XLSX.read(data, { type: 'array', cellDates: true });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // 2. Use raw: false to get formatted values if needed, 
        // but since we want to handle dates specifically, header: 1 is fine
        const jsonData: any[][] = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          blankrows: false,
        });

        if (jsonData.length === 0) {
          resolve({ headers: [], rows: [] });
          return;
        }

        const headers = (jsonData[0] as string[]) || [];
        const headerObjects = headers.map((h) => ({
          title: h || '',
          key: h || `col_${h}`,
        }));

        const rows = jsonData
          .slice(1)
          .map((row: any[]) => {
            const obj: Record<string, any> = {};
            headers.forEach((header, i) => {
              let cellValue = row[i];

              // Check if this column is a Date of Birth or similar date field
              const isDateField = header.toLowerCase().includes('dob') || 
                                 header.toLowerCase().includes('date');

              if (isDateField && cellValue) {
                // Scenario A: XLSX already converted it to a JS Date object
                if (cellValue instanceof Date) {
                  if (!isNaN(cellValue.getTime())) {
                    obj[header] = cellValue.toISOString(); // Format: 2022-10-23T00:00:00.000Z
                  } else {
                    obj[header] = null; // Invalid date
                  }
                } 
                // Scenario B: It's a string (e.g., "23/12/2022")
                else if (typeof cellValue === 'string') {
                  const parsedDate = new Date(cellValue);
                  if (!isNaN(parsedDate.getTime())) {
                    obj[header] = parsedDate.toISOString();
                  } else {
                    // Fallback: If it's a "DD/MM/YYYY" string that JS Date can't parse
                    const parts = cellValue.split(/[/ -]/);
                    if (parts.length === 3) {
                      // Attempt to construct YYYY-MM-DD
                      const d = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                      obj[header] = !isNaN(d.getTime()) ? d.toISOString() : cellValue;
                    } else {
                      obj[header] = cellValue; 
                    }
                  }
                }
              } else {
                obj[header] = cellValue;
              }
            });
            return obj;
          });

        resolve({
          headers: headerObjects,
          rows,
        });
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => reject(new Error('Error reading file'));
    
    // Changed to readAsArrayBuffer (modern standard for XLSX)
    reader.readAsArrayBuffer(file);
  });
};

export { handleFileUpload };

